// Labels for job openings (match the backend's choices on LabPosition)
export const KIND = {
  phd: 'PhD', postdoc: 'Postdoc', masters: "Master's", ra: 'Research assistant', technician: 'Technician',
  intern: 'Intern', scientist: 'Scientist', engineer: 'Engineer', faculty: 'Faculty', manager: 'Project / lab manager',
  other: 'Other',
};
export const EMPLOYMENT = {
  full_time: 'Full-time', part_time: 'Part-time', fellowship: 'Fellowship / scholarship', internship: 'Internship',
  contract: 'Contract',
};
export const WORK_MODE = { onsite: 'On site', hybrid: 'Hybrid', remote: 'Remote' };
export const HOST_LABEL = { lab: 'Lab', consortium: 'Consortium', organization: 'Organization' };

export const fmtDeadline = (d) => (d ? new Date(d).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : '');
export const daysLeft = (d) => (d ? Math.ceil((new Date(d) - new Date()) / 86400000) : null);
